import React from 'react'
import Lottie from 'react-lottie'
import * as animationData from '../../assets/icerik_bulunamadi.json'
import './Empty.css'

const Empty = ({ text = 'Veri bulunmamaktadır.', compact = false }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div className={`emptyCard${compact ? ' emptyCard--compact' : ''}`}>
      <div className='emptyCard__content'>
        <div className='emptyCard__animation'>
          <Lottie options={defaultOptions} height={compact ? 72 : 88} width={compact ? 72 : 88} />
        </div>
        <p className='emptyCard__text'>{text}</p>
      </div>
    </div>
  )
}

export default Empty
